// Web entry point. Mounts window.api BEFORE the React tree imports any
// component that touches it. Two modes:
//   - Firebase configured (VITE_FIREBASE_API_KEY set) → render the AuthGate,
//     which shows the login screen until a user signs in.
//   - No-login mode (no Firebase config) → render the shared app directly.
//     The backend accepts unauthenticated requests as a shared workspace
//     user (AUTH_DISABLED). See apiserver/README.md.

import React from 'react';
import { createRoot } from 'react-dom/client';
import { installApi } from './api/index.js';
import { reconnect } from './api/ws.js';
import { ensureMediaToken } from './api/http.js';
import { AUTH_ENABLED } from './auth/firebase.js';
import './auth/auth.css';

installApi();

await import('@app/styles/index.css');

const root = createRoot(document.getElementById('root'));

if (AUTH_ENABLED) {
  const { default: AuthGate } = await import('./auth/AuthGate.jsx');
  root.render(<AuthGate />);
} else {
  // No-login mode: load the shared app immediately.
  const { default: App } = await import('@app/App.jsx');
  if (window.api) {
    window.api.capabilities = { ...(window.api.capabilities || {}), logs: false };
  }
  // Even without login the server hands out media tokens for the shared user,
  // and media URLs and the socket need one before the app renders.
  await ensureMediaToken().catch(() => {});
  reconnect(); // open the /ws log/progress socket
  root.render(<App />);
}
